// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file api/v1/api.proto (package api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/api.proto.
 */
export const file_api_v1_api: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp, file_google_protobuf_struct]);

/**
 * @generated from message api.v1.BlockUserRequest
 */
export type BlockUserRequest = Message$1<"api.v1.BlockUserRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.BlockUserRequest.
 * Use `create(BlockUserRequestSchema)` to create a new message.
 */
export const BlockUserRequestSchema: GenMessage<BlockUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 0);

/**
 * @generated from message api.v1.BookmarkPostRequest
 */
export type BookmarkPostRequest = Message$1<"api.v1.BookmarkPostRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;
};

/**
 * Describes the message api.v1.BookmarkPostRequest.
 * Use `create(BookmarkPostRequestSchema)` to create a new message.
 */
export const BookmarkPostRequestSchema: GenMessage<BookmarkPostRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 1);

/**
 * @generated from message api.v1.BookmarkPostResponse
 */
export type BookmarkPostResponse = Message$1<"api.v1.BookmarkPostResponse"> & {
  /**
   * @generated from field: string bookmark_id = 1;
   */
  bookmarkId: string;
};

/**
 * Describes the message api.v1.BookmarkPostResponse.
 * Use `create(BookmarkPostResponseSchema)` to create a new message.
 */
export const BookmarkPostResponseSchema: GenMessage<BookmarkPostResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 2);

/**
 * @generated from message api.v1.CreateBookmarkCategoryRequest
 */
export type CreateBookmarkCategoryRequest = Message$1<"api.v1.CreateBookmarkCategoryRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message api.v1.CreateBookmarkCategoryRequest.
 * Use `create(CreateBookmarkCategoryRequestSchema)` to create a new message.
 */
export const CreateBookmarkCategoryRequestSchema: GenMessage<CreateBookmarkCategoryRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 3);

/**
 * @generated from message api.v1.CreateIntermediateSessionRequest
 */
export type CreateIntermediateSessionRequest = Message$1<"api.v1.CreateIntermediateSessionRequest"> & {
  /**
   * @generated from field: string phone_number = 1;
   */
  phoneNumber: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string google_user_id = 4;
   */
  googleUserId: string;
};

/**
 * Describes the message api.v1.CreateIntermediateSessionRequest.
 * Use `create(CreateIntermediateSessionRequestSchema)` to create a new message.
 */
export const CreateIntermediateSessionRequestSchema: GenMessage<CreateIntermediateSessionRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 4);

/**
 * @generated from message api.v1.CreateIntermediateSessionResponse
 */
export type CreateIntermediateSessionResponse = Message$1<"api.v1.CreateIntermediateSessionResponse"> & {
  /**
   * @generated from field: string intermediate_session_token = 1;
   */
  intermediateSessionToken: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message api.v1.CreateIntermediateSessionResponse.
 * Use `create(CreateIntermediateSessionResponseSchema)` to create a new message.
 */
export const CreateIntermediateSessionResponseSchema: GenMessage<CreateIntermediateSessionResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 5);

/**
 * @generated from message api.v1.CreatePostRequest
 */
export type CreatePostRequest = Message$1<"api.v1.CreatePostRequest"> & {
  /**
   * @generated from field: string file_url = 1;
   */
  fileUrl: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * @generated from field: string category_id = 4;
   */
  categoryId: string;
};

/**
 * Describes the message api.v1.CreatePostRequest.
 * Use `create(CreatePostRequestSchema)` to create a new message.
 */
export const CreatePostRequestSchema: GenMessage<CreatePostRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 6);

/**
 * @generated from message api.v1.CreatePostResponse
 */
export type CreatePostResponse = Message$1<"api.v1.CreatePostResponse"> & {
  /**
   * @generated from field: api.v1.Post post = 1;
   */
  post?: Post;
};

/**
 * Describes the message api.v1.CreatePostResponse.
 * Use `create(CreatePostResponseSchema)` to create a new message.
 */
export const CreatePostResponseSchema: GenMessage<CreatePostResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 7);

/**
 * @generated from message api.v1.CreatePostCommentRequest
 */
export type CreatePostCommentRequest = Message$1<"api.v1.CreatePostCommentRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string replying_to_comment_id = 3;
   */
  replyingToCommentId: string;
};

/**
 * Describes the message api.v1.CreatePostCommentRequest.
 * Use `create(CreatePostCommentRequestSchema)` to create a new message.
 */
export const CreatePostCommentRequestSchema: GenMessage<CreatePostCommentRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 8);

/**
 * @generated from message api.v1.DeleteBookmarkCategoryRequest
 */
export type DeleteBookmarkCategoryRequest = Message$1<"api.v1.DeleteBookmarkCategoryRequest"> & {
  /**
   * @generated from field: string bookmark_category_id = 1;
   */
  bookmarkCategoryId: string;
};

/**
 * Describes the message api.v1.DeleteBookmarkCategoryRequest.
 * Use `create(DeleteBookmarkCategoryRequestSchema)` to create a new message.
 */
export const DeleteBookmarkCategoryRequestSchema: GenMessage<DeleteBookmarkCategoryRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 9);

/**
 * @generated from message api.v1.DeleteBookmarkRequest
 */
export type DeleteBookmarkRequest = Message$1<"api.v1.DeleteBookmarkRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;
};

/**
 * Describes the message api.v1.DeleteBookmarkRequest.
 * Use `create(DeleteBookmarkRequestSchema)` to create a new message.
 */
export const DeleteBookmarkRequestSchema: GenMessage<DeleteBookmarkRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 10);

/**
 * @generated from message api.v1.DeletePostRequest
 */
export type DeletePostRequest = Message$1<"api.v1.DeletePostRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;
};

/**
 * Describes the message api.v1.DeletePostRequest.
 * Use `create(DeletePostRequestSchema)` to create a new message.
 */
export const DeletePostRequestSchema: GenMessage<DeletePostRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 11);

/**
 * @generated from message api.v1.DeletePostCommentRequest
 */
export type DeletePostCommentRequest = Message$1<"api.v1.DeletePostCommentRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;

  /**
   * @generated from field: string comment_id = 2;
   */
  commentId: string;
};

/**
 * Describes the message api.v1.DeletePostCommentRequest.
 * Use `create(DeletePostCommentRequestSchema)` to create a new message.
 */
export const DeletePostCommentRequestSchema: GenMessage<DeletePostCommentRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 12);

/**
 * @generated from message api.v1.ExchangeResponse
 */
export type ExchangeResponse = Message$1<"api.v1.ExchangeResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message api.v1.ExchangeResponse.
 * Use `create(ExchangeResponseSchema)` to create a new message.
 */
export const ExchangeResponseSchema: GenMessage<ExchangeResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 13);

/**
 * @generated from message api.v1.FollowUserRequest
 */
export type FollowUserRequest = Message$1<"api.v1.FollowUserRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.FollowUserRequest.
 * Use `create(FollowUserRequestSchema)` to create a new message.
 */
export const FollowUserRequestSchema: GenMessage<FollowUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 14);

/**
 * @generated from message api.v1.GetGoogleOAuthRedirectURLRequest
 */
export type GetGoogleOAuthRedirectURLRequest = Message$1<"api.v1.GetGoogleOAuthRedirectURLRequest"> & {
  /**
   * @generated from field: string redirect_url = 1;
   */
  redirectUrl: string;
};

/**
 * Describes the message api.v1.GetGoogleOAuthRedirectURLRequest.
 * Use `create(GetGoogleOAuthRedirectURLRequestSchema)` to create a new message.
 */
export const GetGoogleOAuthRedirectURLRequestSchema: GenMessage<GetGoogleOAuthRedirectURLRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 15);

/**
 * @generated from message api.v1.GetGoogleOAuthRedirectURLResponse
 */
export type GetGoogleOAuthRedirectURLResponse = Message$1<"api.v1.GetGoogleOAuthRedirectURLResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message api.v1.GetGoogleOAuthRedirectURLResponse.
 * Use `create(GetGoogleOAuthRedirectURLResponseSchema)` to create a new message.
 */
export const GetGoogleOAuthRedirectURLResponseSchema: GenMessage<GetGoogleOAuthRedirectURLResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 16);

/**
 * @generated from message api.v1.GetMyContentSettingsResponse
 */
export type GetMyContentSettingsResponse = Message$1<"api.v1.GetMyContentSettingsResponse"> & {
  /**
   * @generated from field: bool hide_potentially_sensitive_content = 1;
   */
  hidePotentiallySensitiveContent: boolean;

  /**
   * @generated from field: bool show_sensitive_content_warning = 2;
   */
  showSensitiveContentWarning: boolean;
};

/**
 * Describes the message api.v1.GetMyContentSettingsResponse.
 * Use `create(GetMyContentSettingsResponseSchema)` to create a new message.
 */
export const GetMyContentSettingsResponseSchema: GenMessage<GetMyContentSettingsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 17);

/**
 * @generated from message api.v1.GetMyPrivacySettingsResponse
 */
export type GetMyPrivacySettingsResponse = Message$1<"api.v1.GetMyPrivacySettingsResponse"> & {
  /**
   * @generated from field: bool private_profile = 1;
   */
  privateProfile: boolean;

  /**
   * @generated from field: bool private_followers = 2;
   */
  privateFollowers: boolean;

  /**
   * @generated from field: bool private_likes = 3;
   */
  privateLikes: boolean;

  /**
   * @generated from field: bool private_tags = 4;
   */
  privateTags: boolean;

  /**
   * @generated from field: bool private_bookmarks = 5;
   */
  privateBookmarks: boolean;

  /**
   * @generated from field: bool private_sounds = 6;
   */
  privateSounds: boolean;
};

/**
 * Describes the message api.v1.GetMyPrivacySettingsResponse.
 * Use `create(GetMyPrivacySettingsResponseSchema)` to create a new message.
 */
export const GetMyPrivacySettingsResponseSchema: GenMessage<GetMyPrivacySettingsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 18);

/**
 * @generated from message api.v1.GetPostRequest
 */
export type GetPostRequest = Message$1<"api.v1.GetPostRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;
};

/**
 * Describes the message api.v1.GetPostRequest.
 * Use `create(GetPostRequestSchema)` to create a new message.
 */
export const GetPostRequestSchema: GenMessage<GetPostRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 19);

/**
 * @generated from message api.v1.GetPostResponse
 */
export type GetPostResponse = Message$1<"api.v1.GetPostResponse"> & {
  /**
   * @generated from field: api.v1.Post post = 1;
   */
  post?: Post;
};

/**
 * Describes the message api.v1.GetPostResponse.
 * Use `create(GetPostResponseSchema)` to create a new message.
 */
export const GetPostResponseSchema: GenMessage<GetPostResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 20);

/**
 * @generated from message api.v1.GetUserRequest
 */
export type GetUserRequest = Message$1<"api.v1.GetUserRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 21);

/**
 * @generated from message api.v1.GetUserResponse
 */
export type GetUserResponse = Message$1<"api.v1.GetUserResponse"> & {
  /**
   * @generated from field: api.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message api.v1.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema: GenMessage<GetUserResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 22);

/**
 * @generated from message api.v1.GetUserByUsernameRequest
 */
export type GetUserByUsernameRequest = Message$1<"api.v1.GetUserByUsernameRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;
};

/**
 * Describes the message api.v1.GetUserByUsernameRequest.
 * Use `create(GetUserByUsernameRequestSchema)` to create a new message.
 */
export const GetUserByUsernameRequestSchema: GenMessage<GetUserByUsernameRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 23);

/**
 * @generated from message api.v1.GetUserByUsernameResponse
 */
export type GetUserByUsernameResponse = Message$1<"api.v1.GetUserByUsernameResponse"> & {
  /**
   * @generated from field: api.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message api.v1.GetUserByUsernameResponse.
 * Use `create(GetUserByUsernameResponseSchema)` to create a new message.
 */
export const GetUserByUsernameResponseSchema: GenMessage<GetUserByUsernameResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 24);

/**
 * @generated from message api.v1.GetPresignedUploadURLRequest
 */
export type GetPresignedUploadURLRequest = Message$1<"api.v1.GetPresignedUploadURLRequest"> & {
};

/**
 * Describes the message api.v1.GetPresignedUploadURLRequest.
 * Use `create(GetPresignedUploadURLRequestSchema)` to create a new message.
 */
export const GetPresignedUploadURLRequestSchema: GenMessage<GetPresignedUploadURLRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 25);

/**
 * @generated from message api.v1.GetPresignedUploadURLResponse
 */
export type GetPresignedUploadURLResponse = Message$1<"api.v1.GetPresignedUploadURLResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string file_id = 2;
   */
  fileId: string;
};

/**
 * Describes the message api.v1.GetPresignedUploadURLResponse.
 * Use `create(GetPresignedUploadURLResponseSchema)` to create a new message.
 */
export const GetPresignedUploadURLResponseSchema: GenMessage<GetPresignedUploadURLResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 26);

/**
 * @generated from message api.v1.IssueEmailVerificationChallengeRequest
 */
export type IssueEmailVerificationChallengeRequest = Message$1<"api.v1.IssueEmailVerificationChallengeRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message api.v1.IssueEmailVerificationChallengeRequest.
 * Use `create(IssueEmailVerificationChallengeRequestSchema)` to create a new message.
 */
export const IssueEmailVerificationChallengeRequestSchema: GenMessage<IssueEmailVerificationChallengeRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 27);

/**
 * @generated from message api.v1.IssuePhoneNumberVerificationChallengeRequest
 */
export type IssuePhoneNumberVerificationChallengeRequest = Message$1<"api.v1.IssuePhoneNumberVerificationChallengeRequest"> & {
  /**
   * @generated from field: string phone_number = 1;
   */
  phoneNumber: string;
};

/**
 * Describes the message api.v1.IssuePhoneNumberVerificationChallengeRequest.
 * Use `create(IssuePhoneNumberVerificationChallengeRequestSchema)` to create a new message.
 */
export const IssuePhoneNumberVerificationChallengeRequestSchema: GenMessage<IssuePhoneNumberVerificationChallengeRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 28);

/**
 * @generated from message api.v1.ListCategoriesResponse
 */
export type ListCategoriesResponse = Message$1<"api.v1.ListCategoriesResponse"> & {
  /**
   * @generated from field: repeated api.v1.Category categories = 1;
   */
  categories: Category[];
};

/**
 * Describes the message api.v1.ListCategoriesResponse.
 * Use `create(ListCategoriesResponseSchema)` to create a new message.
 */
export const ListCategoriesResponseSchema: GenMessage<ListCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 29);

/**
 * @generated from message api.v1.LikePostCommentRequest
 */
export type LikePostCommentRequest = Message$1<"api.v1.LikePostCommentRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;

  /**
   * @generated from field: string comment_id = 2;
   */
  commentId: string;
};

/**
 * Describes the message api.v1.LikePostCommentRequest.
 * Use `create(LikePostCommentRequestSchema)` to create a new message.
 */
export const LikePostCommentRequestSchema: GenMessage<LikePostCommentRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 30);

/**
 * @generated from message api.v1.LikePostRequest
 */
export type LikePostRequest = Message$1<"api.v1.LikePostRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;
};

/**
 * Describes the message api.v1.LikePostRequest.
 * Use `create(LikePostRequestSchema)` to create a new message.
 */
export const LikePostRequestSchema: GenMessage<LikePostRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 31);

/**
 * @generated from message api.v1.ListFollowersRequest
 */
export type ListFollowersRequest = Message$1<"api.v1.ListFollowersRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.ListFollowersRequest.
 * Use `create(ListFollowersRequestSchema)` to create a new message.
 */
export const ListFollowersRequestSchema: GenMessage<ListFollowersRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 32);

/**
 * @generated from message api.v1.ListFollowersResponse
 */
export type ListFollowersResponse = Message$1<"api.v1.ListFollowersResponse"> & {
  /**
   * @generated from field: repeated api.v1.User followers = 1;
   */
  followers: User[];
};

/**
 * Describes the message api.v1.ListFollowersResponse.
 * Use `create(ListFollowersResponseSchema)` to create a new message.
 */
export const ListFollowersResponseSchema: GenMessage<ListFollowersResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 33);

/**
 * @generated from message api.v1.ListFollowingRequest
 */
export type ListFollowingRequest = Message$1<"api.v1.ListFollowingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.ListFollowingRequest.
 * Use `create(ListFollowingRequestSchema)` to create a new message.
 */
export const ListFollowingRequestSchema: GenMessage<ListFollowingRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 34);

/**
 * @generated from message api.v1.ListFollowingResponse
 */
export type ListFollowingResponse = Message$1<"api.v1.ListFollowingResponse"> & {
  /**
   * @generated from field: repeated api.v1.User following = 1;
   */
  following: User[];
};

/**
 * Describes the message api.v1.ListFollowingResponse.
 * Use `create(ListFollowingResponseSchema)` to create a new message.
 */
export const ListFollowingResponseSchema: GenMessage<ListFollowingResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 35);

/**
 * @generated from message api.v1.ListMyBlockedUsersResponse
 */
export type ListMyBlockedUsersResponse = Message$1<"api.v1.ListMyBlockedUsersResponse"> & {
  /**
   * @generated from field: repeated api.v1.User blocked_users = 1;
   */
  blockedUsers: User[];
};

/**
 * Describes the message api.v1.ListMyBlockedUsersResponse.
 * Use `create(ListMyBlockedUsersResponseSchema)` to create a new message.
 */
export const ListMyBlockedUsersResponseSchema: GenMessage<ListMyBlockedUsersResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 36);

/**
 * @generated from message api.v1.ListPostsRequest
 */
export type ListPostsRequest = Message$1<"api.v1.ListPostsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 per_page = 2;
   */
  perPage: number;
};

/**
 * Describes the message api.v1.ListPostsRequest.
 * Use `create(ListPostsRequestSchema)` to create a new message.
 */
export const ListPostsRequestSchema: GenMessage<ListPostsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 37);

/**
 * @generated from message api.v1.ListPostsResponse
 */
export type ListPostsResponse = Message$1<"api.v1.ListPostsResponse"> & {
  /**
   * @generated from field: repeated api.v1.Post posts = 1;
   */
  posts: Post[];
};

/**
 * Describes the message api.v1.ListPostsResponse.
 * Use `create(ListPostsResponseSchema)` to create a new message.
 */
export const ListPostsResponseSchema: GenMessage<ListPostsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 38);

/**
 * @generated from message api.v1.ListPostsByUserIDRequest
 */
export type ListPostsByUserIDRequest = Message$1<"api.v1.ListPostsByUserIDRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 per_page = 3;
   */
  perPage: number;
};

/**
 * Describes the message api.v1.ListPostsByUserIDRequest.
 * Use `create(ListPostsByUserIDRequestSchema)` to create a new message.
 */
export const ListPostsByUserIDRequestSchema: GenMessage<ListPostsByUserIDRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 39);

/**
 * @generated from message api.v1.ListPostsByUserIDResponse
 */
export type ListPostsByUserIDResponse = Message$1<"api.v1.ListPostsByUserIDResponse"> & {
  /**
   * @generated from field: repeated api.v1.Post posts = 1;
   */
  posts: Post[];
};

/**
 * Describes the message api.v1.ListPostsByUserIDResponse.
 * Use `create(ListPostsByUserIDResponseSchema)` to create a new message.
 */
export const ListPostsByUserIDResponseSchema: GenMessage<ListPostsByUserIDResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 40);

/**
 * @generated from message api.v1.ListPostCommentsRequest
 */
export type ListPostCommentsRequest = Message$1<"api.v1.ListPostCommentsRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 per_page = 3;
   */
  perPage: number;
};

/**
 * Describes the message api.v1.ListPostCommentsRequest.
 * Use `create(ListPostCommentsRequestSchema)` to create a new message.
 */
export const ListPostCommentsRequestSchema: GenMessage<ListPostCommentsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 41);

/**
 * @generated from message api.v1.ListPostCommentsResponse
 */
export type ListPostCommentsResponse = Message$1<"api.v1.ListPostCommentsResponse"> & {
  /**
   * @generated from field: repeated api.v1.PostComment comments = 1;
   */
  comments: PostComment[];
};

/**
 * Describes the message api.v1.ListPostCommentsResponse.
 * Use `create(ListPostCommentsResponseSchema)` to create a new message.
 */
export const ListPostCommentsResponseSchema: GenMessage<ListPostCommentsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 42);

/**
 * @generated from message api.v1.ListPostCommentRepliesRequest
 */
export type ListPostCommentRepliesRequest = Message$1<"api.v1.ListPostCommentRepliesRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;

  /**
   * @generated from field: string comment_id = 2;
   */
  commentId: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 per_page = 4;
   */
  perPage: number;
};

/**
 * Describes the message api.v1.ListPostCommentRepliesRequest.
 * Use `create(ListPostCommentRepliesRequestSchema)` to create a new message.
 */
export const ListPostCommentRepliesRequestSchema: GenMessage<ListPostCommentRepliesRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 43);

/**
 * @generated from message api.v1.ListPostCommentRepliesResponse
 */
export type ListPostCommentRepliesResponse = Message$1<"api.v1.ListPostCommentRepliesResponse"> & {
  /**
   * @generated from field: repeated api.v1.PostComment comments = 1;
   */
  comments: PostComment[];
};

/**
 * Describes the message api.v1.ListPostCommentRepliesResponse.
 * Use `create(ListPostCommentRepliesResponseSchema)` to create a new message.
 */
export const ListPostCommentRepliesResponseSchema: GenMessage<ListPostCommentRepliesResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 44);

/**
 * @generated from message api.v1.RedeemGoogleOAuthCodeRequest
 */
export type RedeemGoogleOAuthCodeRequest = Message$1<"api.v1.RedeemGoogleOAuthCodeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string redirect_url = 2;
   */
  redirectUrl: string;

  /**
   * @generated from field: string state = 3;
   */
  state: string;
};

/**
 * Describes the message api.v1.RedeemGoogleOAuthCodeRequest.
 * Use `create(RedeemGoogleOAuthCodeRequestSchema)` to create a new message.
 */
export const RedeemGoogleOAuthCodeRequestSchema: GenMessage<RedeemGoogleOAuthCodeRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 45);

/**
 * @generated from message api.v1.RefreshResponse
 */
export type RefreshResponse = Message$1<"api.v1.RefreshResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message api.v1.RefreshResponse.
 * Use `create(RefreshResponseSchema)` to create a new message.
 */
export const RefreshResponseSchema: GenMessage<RefreshResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 46);

/**
 * @generated from message api.v1.RegisterPasswordRequest
 */
export type RegisterPasswordRequest = Message$1<"api.v1.RegisterPasswordRequest"> & {
  /**
   * @generated from field: string password = 1;
   */
  password: string;
};

/**
 * Describes the message api.v1.RegisterPasswordRequest.
 * Use `create(RegisterPasswordRequestSchema)` to create a new message.
 */
export const RegisterPasswordRequestSchema: GenMessage<RegisterPasswordRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 47);

/**
 * @generated from message api.v1.RemoveFollowerRequest
 */
export type RemoveFollowerRequest = Message$1<"api.v1.RemoveFollowerRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.RemoveFollowerRequest.
 * Use `create(RemoveFollowerRequestSchema)` to create a new message.
 */
export const RemoveFollowerRequestSchema: GenMessage<RemoveFollowerRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 48);

/**
 * @generated from message api.v1.SetIntermediateSessionEmailRequest
 */
export type SetIntermediateSessionEmailRequest = Message$1<"api.v1.SetIntermediateSessionEmailRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message api.v1.SetIntermediateSessionEmailRequest.
 * Use `create(SetIntermediateSessionEmailRequestSchema)` to create a new message.
 */
export const SetIntermediateSessionEmailRequestSchema: GenMessage<SetIntermediateSessionEmailRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 49);

/**
 * @generated from message api.v1.SetIntermediateSessionPhoneNumberRequest
 */
export type SetIntermediateSessionPhoneNumberRequest = Message$1<"api.v1.SetIntermediateSessionPhoneNumberRequest"> & {
  /**
   * @generated from field: string phone_number = 1;
   */
  phoneNumber: string;
};

/**
 * Describes the message api.v1.SetIntermediateSessionPhoneNumberRequest.
 * Use `create(SetIntermediateSessionPhoneNumberRequestSchema)` to create a new message.
 */
export const SetIntermediateSessionPhoneNumberRequestSchema: GenMessage<SetIntermediateSessionPhoneNumberRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 50);

/**
 * @generated from message api.v1.SetIntermediateSessionUsernameRequest
 */
export type SetIntermediateSessionUsernameRequest = Message$1<"api.v1.SetIntermediateSessionUsernameRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;
};

/**
 * Describes the message api.v1.SetIntermediateSessionUsernameRequest.
 * Use `create(SetIntermediateSessionUsernameRequestSchema)` to create a new message.
 */
export const SetIntermediateSessionUsernameRequestSchema: GenMessage<SetIntermediateSessionUsernameRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 51);

/**
 * @generated from message api.v1.UnblockUserRequest
 */
export type UnblockUserRequest = Message$1<"api.v1.UnblockUserRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.UnblockUserRequest.
 * Use `create(UnblockUserRequestSchema)` to create a new message.
 */
export const UnblockUserRequestSchema: GenMessage<UnblockUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 52);

/**
 * @generated from message api.v1.UnfollowUserRequest
 */
export type UnfollowUserRequest = Message$1<"api.v1.UnfollowUserRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.UnfollowUserRequest.
 * Use `create(UnfollowUserRequestSchema)` to create a new message.
 */
export const UnfollowUserRequestSchema: GenMessage<UnfollowUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 53);

/**
 * @generated from message api.v1.UnlikePostRequest
 */
export type UnlikePostRequest = Message$1<"api.v1.UnlikePostRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;
};

/**
 * Describes the message api.v1.UnlikePostRequest.
 * Use `create(UnlikePostRequestSchema)` to create a new message.
 */
export const UnlikePostRequestSchema: GenMessage<UnlikePostRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 54);

/**
 * @generated from message api.v1.UnlikePostCommentRequest
 */
export type UnlikePostCommentRequest = Message$1<"api.v1.UnlikePostCommentRequest"> & {
  /**
   * @generated from field: string post_id = 1;
   */
  postId: string;

  /**
   * @generated from field: string comment_id = 2;
   */
  commentId: string;
};

/**
 * Describes the message api.v1.UnlikePostCommentRequest.
 * Use `create(UnlikePostCommentRequestSchema)` to create a new message.
 */
export const UnlikePostCommentRequestSchema: GenMessage<UnlikePostCommentRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 55);

/**
 * @generated from message api.v1.UpdateBookmarkRequest
 */
export type UpdateBookmarkRequest = Message$1<"api.v1.UpdateBookmarkRequest"> & {
  /**
   * @generated from field: string bookmark_id = 1;
   */
  bookmarkId: string;

  /**
   * @generated from field: string category_id = 2;
   */
  categoryId: string;
};

/**
 * Describes the message api.v1.UpdateBookmarkRequest.
 * Use `create(UpdateBookmarkRequestSchema)` to create a new message.
 */
export const UpdateBookmarkRequestSchema: GenMessage<UpdateBookmarkRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 56);

/**
 * @generated from message api.v1.UpdateMeRequest
 */
export type UpdateMeRequest = Message$1<"api.v1.UpdateMeRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string bio = 3;
   */
  bio: string;

  /**
   * @generated from field: string website = 4;
   */
  website: string;
};

/**
 * Describes the message api.v1.UpdateMeRequest.
 * Use `create(UpdateMeRequestSchema)` to create a new message.
 */
export const UpdateMeRequestSchema: GenMessage<UpdateMeRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 57);

/**
 * @generated from message api.v1.UpdateMyContentSettingsRequest
 */
export type UpdateMyContentSettingsRequest = Message$1<"api.v1.UpdateMyContentSettingsRequest"> & {
  /**
   * @generated from field: bool hide_potentially_sensitive_content = 1;
   */
  hidePotentiallySensitiveContent: boolean;

  /**
   * @generated from field: bool show_sensitive_content_warning = 2;
   */
  showSensitiveContentWarning: boolean;
};

/**
 * Describes the message api.v1.UpdateMyContentSettingsRequest.
 * Use `create(UpdateMyContentSettingsRequestSchema)` to create a new message.
 */
export const UpdateMyContentSettingsRequestSchema: GenMessage<UpdateMyContentSettingsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 58);

/**
 * @generated from message api.v1.UpdateMyPrivacySettingsRequest
 */
export type UpdateMyPrivacySettingsRequest = Message$1<"api.v1.UpdateMyPrivacySettingsRequest"> & {
  /**
   * @generated from field: bool private_profile = 1;
   */
  privateProfile: boolean;

  /**
   * @generated from field: bool private_followers = 2;
   */
  privateFollowers: boolean;

  /**
   * @generated from field: bool private_likes = 3;
   */
  privateLikes: boolean;

  /**
   * @generated from field: bool private_tags = 4;
   */
  privateTags: boolean;

  /**
   * @generated from field: bool private_bookmarks = 5;
   */
  privateBookmarks: boolean;

  /**
   * @generated from field: bool private_sounds = 6;
   */
  privateSounds: boolean;
};

/**
 * Describes the message api.v1.UpdateMyPrivacySettingsRequest.
 * Use `create(UpdateMyPrivacySettingsRequestSchema)` to create a new message.
 */
export const UpdateMyPrivacySettingsRequestSchema: GenMessage<UpdateMyPrivacySettingsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 59);

/**
 * @generated from message api.v1.UpdateMyProfilePictureRequest
 */
export type UpdateMyProfilePictureRequest = Message$1<"api.v1.UpdateMyProfilePictureRequest"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message api.v1.UpdateMyProfilePictureRequest.
 * Use `create(UpdateMyProfilePictureRequestSchema)` to create a new message.
 */
export const UpdateMyProfilePictureRequestSchema: GenMessage<UpdateMyProfilePictureRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 60);

/**
 * @generated from message api.v1.VerifyEmailVerificationChallengeRequest
 */
export type VerifyEmailVerificationChallengeRequest = Message$1<"api.v1.VerifyEmailVerificationChallengeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message api.v1.VerifyEmailVerificationChallengeRequest.
 * Use `create(VerifyEmailVerificationChallengeRequestSchema)` to create a new message.
 */
export const VerifyEmailVerificationChallengeRequestSchema: GenMessage<VerifyEmailVerificationChallengeRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 61);

/**
 * @generated from message api.v1.VerifyPasswordRequest
 */
export type VerifyPasswordRequest = Message$1<"api.v1.VerifyPasswordRequest"> & {
  /**
   * @generated from field: string password = 1;
   */
  password: string;
};

/**
 * Describes the message api.v1.VerifyPasswordRequest.
 * Use `create(VerifyPasswordRequestSchema)` to create a new message.
 */
export const VerifyPasswordRequestSchema: GenMessage<VerifyPasswordRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 62);

/**
 * @generated from message api.v1.VerifyPhoneNumberVerificationChallengeRequest
 */
export type VerifyPhoneNumberVerificationChallengeRequest = Message$1<"api.v1.VerifyPhoneNumberVerificationChallengeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message api.v1.VerifyPhoneNumberVerificationChallengeRequest.
 * Use `create(VerifyPhoneNumberVerificationChallengeRequestSchema)` to create a new message.
 */
export const VerifyPhoneNumberVerificationChallengeRequestSchema: GenMessage<VerifyPhoneNumberVerificationChallengeRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 63);

/**
 * @generated from message api.v1.WhoamiResponse
 */
export type WhoamiResponse = Message$1<"api.v1.WhoamiResponse"> & {
  /**
   * @generated from field: optional api.v1.IntermediateSession intermediate_session = 1;
   */
  intermediateSession?: IntermediateSession;

  /**
   * @generated from field: optional api.v1.SessionClaims session_claims = 2;
   */
  sessionClaims?: SessionClaims;
};

/**
 * Describes the message api.v1.WhoamiResponse.
 * Use `create(WhoamiResponseSchema)` to create a new message.
 */
export const WhoamiResponseSchema: GenMessage<WhoamiResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 64);

/**
 * @generated from message api.v1.ErrorDetail
 */
export type ErrorDetail = Message$1<"api.v1.ErrorDetail"> & {
  /**
   * @generated from field: string description = 1;
   */
  description: string;

  /**
   * @generated from field: string docs_link = 2;
   */
  docsLink: string;
};

/**
 * Describes the message api.v1.ErrorDetail.
 * Use `create(ErrorDetailSchema)` to create a new message.
 */
export const ErrorDetailSchema: GenMessage<ErrorDetail> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 65);

/**
 * @generated from message api.v1.SessionClaims
 */
export type SessionClaims = Message$1<"api.v1.SessionClaims"> & {
  /**
   * @generated from field: string iss = 1;
   */
  iss: string;

  /**
   * @generated from field: string sub = 2;
   */
  sub: string;

  /**
   * @generated from field: string aud = 3;
   */
  aud: string;

  /**
   * @generated from field: int64 nbf = 4;
   */
  nbf: bigint;

  /**
   * @generated from field: int64 iat = 5;
   */
  iat: bigint;

  /**
   * @generated from field: int64 exp = 6;
   */
  exp: bigint;

  /**
   * @generated from field: api.v1.User user = 7;
   */
  user?: User;

  /**
   * @generated from field: api.v1.Session session = 8;
   */
  session?: Session;
};

/**
 * Describes the message api.v1.SessionClaims.
 * Use `create(SessionClaimsSchema)` to create a new message.
 */
export const SessionClaimsSchema: GenMessage<SessionClaims> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 66);

/**
 * @generated from message api.v1.Bookmark
 */
export type Bookmark = Message$1<"api.v1.Bookmark"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string post_id = 3;
   */
  postId: string;

  /**
   * @generated from field: string bookmark_category_id = 4;
   */
  bookmarkCategoryId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Bookmark.
 * Use `create(BookmarkSchema)` to create a new message.
 */
export const BookmarkSchema: GenMessage<Bookmark> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 67);

/**
 * @generated from message api.v1.BookmarkCategory
 */
export type BookmarkCategory = Message$1<"api.v1.BookmarkCategory"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.BookmarkCategory.
 * Use `create(BookmarkCategorySchema)` to create a new message.
 */
export const BookmarkCategorySchema: GenMessage<BookmarkCategory> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 68);

/**
 * @generated from message api.v1.Category
 */
export type Category = Message$1<"api.v1.Category"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema: GenMessage<Category> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 69);

/**
 * @generated from message api.v1.Chat
 */
export type Chat = Message$1<"api.v1.Chat"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string chat_id = 2;
   */
  chatId: string;

  /**
   * @generated from field: repeated string user_ids = 3;
   */
  userIds: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Chat.
 * Use `create(ChatSchema)` to create a new message.
 */
export const ChatSchema: GenMessage<Chat> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 70);

/**
 * @generated from message api.v1.Follow
 */
export type Follow = Message$1<"api.v1.Follow"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string follower_id = 2;
   */
  followerId: string;

  /**
   * @generated from field: string followee_id = 3;
   */
  followeeId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Follow.
 * Use `create(FollowSchema)` to create a new message.
 */
export const FollowSchema: GenMessage<Follow> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 71);

/**
 * @generated from message api.v1.IntermediateSession
 */
export type IntermediateSession = Message$1<"api.v1.IntermediateSession"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string phone_number = 3;
   */
  phoneNumber: string;

  /**
   * @generated from field: string username = 4;
   */
  username: string;

  /**
   * @generated from field: string google_user_id = 5;
   */
  googleUserId: string;

  /**
   * @generated from field: bool email_verified = 6;
   */
  emailVerified: boolean;

  /**
   * @generated from field: bool phone_number_verified = 7;
   */
  phoneNumberVerified: boolean;

  /**
   * @generated from field: bool password_verified = 8;
   */
  passwordVerified: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 9;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.IntermediateSession.
 * Use `create(IntermediateSessionSchema)` to create a new message.
 */
export const IntermediateSessionSchema: GenMessage<IntermediateSession> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 72);

/**
 * @generated from message api.v1.Live
 */
export type Live = Message$1<"api.v1.Live"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string category_id = 5;
   */
  categoryId: string;

  /**
   * @generated from field: string live_url = 6;
   */
  liveUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 7;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp ended_at = 8;
   */
  endedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Live.
 * Use `create(LiveSchema)` to create a new message.
 */
export const LiveSchema: GenMessage<Live> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 73);

/**
 * @generated from message api.v1.LiveLike
 */
export type LiveLike = Message$1<"api.v1.LiveLike"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string live_id = 3;
   */
  liveId: string;

  /**
   * @generated from field: int32 count = 4;
   */
  count: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.LiveLike.
 * Use `create(LiveLikeSchema)` to create a new message.
 */
export const LiveLikeSchema: GenMessage<LiveLike> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 74);

/**
 * @generated from message api.v1.LiveWatcher
 */
export type LiveWatcher = Message$1<"api.v1.LiveWatcher"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string live_id = 3;
   */
  liveId: string;

  /**
   * @generated from field: google.protobuf.Timestamp left_at = 4;
   */
  leftAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.LiveWatcher.
 * Use `create(LiveWatcherSchema)` to create a new message.
 */
export const LiveWatcherSchema: GenMessage<LiveWatcher> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 75);

/**
 * @generated from message api.v1.Message
 */
export type Message = Message$1<"api.v1.Message"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string chat_id = 2;
   */
  chatId: string;

  /**
   * @generated from field: string sender_id = 3;
   */
  senderId: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: string replying_to_message_id = 5;
   */
  replyingToMessageId: string;

  /**
   * @generated from field: bool read = 6;
   */
  read: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 7;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 76);

/**
 * @generated from message api.v1.MessageReaction
 */
export type MessageReaction = Message$1<"api.v1.MessageReaction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string reaction = 4;
   */
  reaction: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.MessageReaction.
 * Use `create(MessageReactionSchema)` to create a new message.
 */
export const MessageReactionSchema: GenMessage<MessageReaction> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 77);

/**
 * @generated from message api.v1.Notification
 */
export type Notification = Message$1<"api.v1.Notification"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * @generated from field: bool read = 5;
   */
  read: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 78);

/**
 * @generated from message api.v1.PhoneNumberVerificationChallenge
 */
export type PhoneNumberVerificationChallenge = Message$1<"api.v1.PhoneNumberVerificationChallenge"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string phone_number = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: bytes challenge_sha256 = 3;
   */
  challengeSha256: Uint8Array;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 4;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.PhoneNumberVerificationChallenge.
 * Use `create(PhoneNumberVerificationChallengeSchema)` to create a new message.
 */
export const PhoneNumberVerificationChallengeSchema: GenMessage<PhoneNumberVerificationChallenge> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 79);

/**
 * @generated from message api.v1.Post
 */
export type Post = Message$1<"api.v1.Post"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string file_url = 5;
   */
  fileUrl: string;

  /**
   * @generated from field: string category_id = 6;
   */
  categoryId: string;

  /**
   * @generated from field: int64 like_count = 7;
   */
  likeCount: bigint;

  /**
   * @generated from field: int64 comment_count = 8;
   */
  commentCount: bigint;

  /**
   * @generated from field: api.v1.User user = 9;
   */
  user?: User;

  /**
   * @generated from field: optional bool bookmarked_by_me = 10;
   */
  bookmarkedByMe?: boolean;

  /**
   * @generated from field: optional bool liked_by_me = 11;
   */
  likedByMe?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 12;
   */
  publishedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Post.
 * Use `create(PostSchema)` to create a new message.
 */
export const PostSchema: GenMessage<Post> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 80);

/**
 * @generated from message api.v1.PostComment
 */
export type PostComment = Message$1<"api.v1.PostComment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string post_id = 3;
   */
  postId: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: string replying_to_comment_id = 5;
   */
  replyingToCommentId: string;

  /**
   * @generated from field: int64 like_count = 6;
   */
  likeCount: bigint;

  /**
   * @generated from field: int64 reply_count = 7;
   */
  replyCount: bigint;

  /**
   * @generated from field: api.v1.User user = 8;
   */
  user?: User;

  /**
   * @generated from field: optional bool liked_by_me = 9;
   */
  likedByMe?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message api.v1.PostComment.
 * Use `create(PostCommentSchema)` to create a new message.
 */
export const PostCommentSchema: GenMessage<PostComment> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 81);

/**
 * @generated from message api.v1.PostCommentLike
 */
export type PostCommentLike = Message$1<"api.v1.PostCommentLike"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string comment_id = 3;
   */
  commentId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.PostCommentLike.
 * Use `create(PostCommentLikeSchema)` to create a new message.
 */
export const PostCommentLikeSchema: GenMessage<PostCommentLike> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 82);

/**
 * @generated from message api.v1.PostLike
 */
export type PostLike = Message$1<"api.v1.PostLike"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string post_id = 3;
   */
  postId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.PostLike.
 * Use `create(PostLikeSchema)` to create a new message.
 */
export const PostLikeSchema: GenMessage<PostLike> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 83);

/**
 * @generated from message api.v1.Session
 */
export type Session = Message$1<"api.v1.Session"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string intermediate_session_id = 3;
   */
  intermediateSessionId: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 84);

/**
 * @generated from message api.v1.User
 */
export type User = Message$1<"api.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: optional bool has_password = 3;
   */
  hasPassword?: boolean;

  /**
   * @generated from field: optional string email = 4;
   */
  email?: string;

  /**
   * @generated from field: optional string phone_number = 5;
   */
  phoneNumber?: string;

  /**
   * @generated from field: optional string display_name = 6;
   */
  displayName?: string;

  /**
   * @generated from field: optional string google_user_id = 7;
   */
  googleUserId?: string;

  /**
   * @generated from field: optional string profile_picture_url = 8;
   */
  profilePictureUrl?: string;

  /**
   * @generated from field: optional string website = 9;
   */
  website?: string;

  /**
   * @generated from field: optional string bio = 10;
   */
  bio?: string;

  /**
   * @generated from field: optional int64 followers = 11;
   */
  followers?: bigint;

  /**
   * @generated from field: optional int64 following = 12;
   */
  following?: bigint;

  /**
   * @generated from field: optional int64 posts = 13;
   */
  posts?: bigint;

  /**
   * @generated from field: optional int64 likes = 14;
   */
  likes?: bigint;

  /**
   * @generated from field: optional bool followed_by_me = 15;
   */
  followedByMe?: boolean;

  /**
   * @generated from field: optional bool following_me = 16;
   */
  followingMe?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 18;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 85);

/**
 * @generated from message api.v1.UserInterest
 */
export type UserInterest = Message$1<"api.v1.UserInterest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string interest_id = 3;
   */
  interestId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.UserInterest.
 * Use `create(UserInterestSchema)` to create a new message.
 */
export const UserInterestSchema: GenMessage<UserInterest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 86);

/**
 * @generated from message api.v1.UserSetting
 */
export type UserSetting = Message$1<"api.v1.UserSetting"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: bool dark_mode = 3;
   */
  darkMode: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.UserSetting.
 * Use `create(UserSettingSchema)` to create a new message.
 */
export const UserSettingSchema: GenMessage<UserSetting> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 87);

/**
 * @generated from message api.v1.Watch
 */
export type Watch = Message$1<"api.v1.Watch"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string post_id = 3;
   */
  postId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Watch.
 * Use `create(WatchSchema)` to create a new message.
 */
export const WatchSchema: GenMessage<Watch> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 88);

/**
 * @generated from service api.v1.ApiService
 */
export const ApiService: GenService<{
  /**
   * @generated from rpc api.v1.ApiService.GetPost
   */
  getPost: {
    methodKind: "unary";
    input: typeof GetPostRequestSchema;
    output: typeof GetPostResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof GetUserResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.ListCategories
   */
  listCategories: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListCategoriesResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.ListFollowers
   */
  listFollowers: {
    methodKind: "unary";
    input: typeof ListFollowersRequestSchema;
    output: typeof ListFollowersResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.ListFollowing
   */
  listFollowing: {
    methodKind: "unary";
    input: typeof ListFollowingRequestSchema;
    output: typeof ListFollowingResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.ListPosts
   */
  listPosts: {
    methodKind: "unary";
    input: typeof ListPostsRequestSchema;
    output: typeof ListPostsResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.ListPostsByUserID
   */
  listPostsByUserID: {
    methodKind: "unary";
    input: typeof ListPostsByUserIDRequestSchema;
    output: typeof ListPostsByUserIDResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.ListPostComments
   */
  listPostComments: {
    methodKind: "unary";
    input: typeof ListPostCommentsRequestSchema;
    output: typeof ListPostCommentsResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.Refresh
   */
  refresh: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof RefreshResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.Whoami
   */
  whoami: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof WhoamiResponseSchema;
  },
  /**
   * Blocked users
   *
   * @generated from rpc api.v1.ApiService.BlockUser
   */
  blockUser: {
    methodKind: "unary";
    input: typeof BlockUserRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.UnblockUser
   */
  unblockUser: {
    methodKind: "unary";
    input: typeof UnblockUserRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Bookmarks
   *
   * @generated from rpc api.v1.ApiService.BookmarkPost
   */
  bookmarkPost: {
    methodKind: "unary";
    input: typeof BookmarkPostRequestSchema;
    output: typeof BookmarkPostResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.DeleteBookmark
   */
  deleteBookmark: {
    methodKind: "unary";
    input: typeof DeleteBookmarkRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.UpdateBookmark
   */
  updateBookmark: {
    methodKind: "unary";
    input: typeof UpdateBookmarkRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Bookmark Categories
   *
   * @generated from rpc api.v1.ApiService.CreateBookmarkCategory
   */
  createBookmarkCategory: {
    methodKind: "unary";
    input: typeof CreateBookmarkCategoryRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.DeleteBookmarkCategory
   */
  deleteBookmarkCategory: {
    methodKind: "unary";
    input: typeof DeleteBookmarkCategoryRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Follows
   *
   * @generated from rpc api.v1.ApiService.FollowUser
   */
  followUser: {
    methodKind: "unary";
    input: typeof FollowUserRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.RemoveFollower
   */
  removeFollower: {
    methodKind: "unary";
    input: typeof RemoveFollowerRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.UnfollowUser
   */
  unfollowUser: {
    methodKind: "unary";
    input: typeof UnfollowUserRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Posts
   *
   * @generated from rpc api.v1.ApiService.CreatePost
   */
  createPost: {
    methodKind: "unary";
    input: typeof CreatePostRequestSchema;
    output: typeof CreatePostResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.DeletePost
   */
  deletePost: {
    methodKind: "unary";
    input: typeof DeletePostRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.LikePost
   */
  likePost: {
    methodKind: "unary";
    input: typeof LikePostRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.UnlikePost
   */
  unlikePost: {
    methodKind: "unary";
    input: typeof UnlikePostRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Post Comments
   *
   * @generated from rpc api.v1.ApiService.CreatePostComment
   */
  createPostComment: {
    methodKind: "unary";
    input: typeof CreatePostCommentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.DeletePostComment
   */
  deletePostComment: {
    methodKind: "unary";
    input: typeof DeletePostCommentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.LikePostComment
   */
  likePostComment: {
    methodKind: "unary";
    input: typeof LikePostCommentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.ListPostCommentReplies
   */
  listPostCommentReplies: {
    methodKind: "unary";
    input: typeof ListPostCommentRepliesRequestSchema;
    output: typeof ListPostCommentRepliesResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.UnlikePostComment
   */
  unlikePostComment: {
    methodKind: "unary";
    input: typeof UnlikePostCommentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Me
   *
   * @generated from rpc api.v1.ApiService.GetMyContentSettings
   */
  getMyContentSettings: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetMyContentSettingsResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.GetMyPrivacySettings
   */
  getMyPrivacySettings: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetMyPrivacySettingsResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.ListMyBlockedUsers
   */
  listMyBlockedUsers: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListMyBlockedUsersResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.UpdateMe
   */
  updateMe: {
    methodKind: "unary";
    input: typeof UpdateMeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.UpdateMyContentSettings
   */
  updateMyContentSettings: {
    methodKind: "unary";
    input: typeof UpdateMyContentSettingsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.UpdateMyPrivacySettings
   */
  updateMyPrivacySettings: {
    methodKind: "unary";
    input: typeof UpdateMyPrivacySettingsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.UpdateMyProfilePicture
   */
  updateMyProfilePicture: {
    methodKind: "unary";
    input: typeof UpdateMyProfilePictureRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Users
   *
   * @generated from rpc api.v1.ApiService.GetUserByUsername
   */
  getUserByUsername: {
    methodKind: "unary";
    input: typeof GetUserByUsernameRequestSchema;
    output: typeof GetUserByUsernameResponseSchema;
  },
  /**
   * OAuth
   *
   * @generated from rpc api.v1.ApiService.GetGoogleOAuthRedirectURL
   */
  getGoogleOAuthRedirectURL: {
    methodKind: "unary";
    input: typeof GetGoogleOAuthRedirectURLRequestSchema;
    output: typeof GetGoogleOAuthRedirectURLResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.RedeemGoogleOAuthCode
   */
  redeemGoogleOAuthCode: {
    methodKind: "unary";
    input: typeof RedeemGoogleOAuthCodeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Uploads
   *
   * @generated from rpc api.v1.ApiService.GetPresignedUploadURL
   */
  getPresignedUploadURL: {
    methodKind: "unary";
    input: typeof GetPresignedUploadURLRequestSchema;
    output: typeof GetPresignedUploadURLResponseSchema;
  },
  /**
   * Intermediate Sessions
   *
   * @generated from rpc api.v1.ApiService.CreateIntermediateSession
   */
  createIntermediateSession: {
    methodKind: "unary";
    input: typeof CreateIntermediateSessionRequestSchema;
    output: typeof CreateIntermediateSessionResponseSchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.RevokeIntermediateSession
   */
  revokeIntermediateSession: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.SetIntermediateSessionEmail
   */
  setIntermediateSessionEmail: {
    methodKind: "unary";
    input: typeof SetIntermediateSessionEmailRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.SetIntermediateSessionPhoneNumber
   */
  setIntermediateSessionPhoneNumber: {
    methodKind: "unary";
    input: typeof SetIntermediateSessionPhoneNumberRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.SetIntermediateSessionUsername
   */
  setIntermediateSessionUsername: {
    methodKind: "unary";
    input: typeof SetIntermediateSessionUsernameRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Sessions
   *
   * @generated from rpc api.v1.ApiService.Exchange
   */
  exchange: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ExchangeResponseSchema;
  },
  /**
   * Verification
   *
   * @generated from rpc api.v1.ApiService.IssueEmailVerificationChallenge
   */
  issueEmailVerificationChallenge: {
    methodKind: "unary";
    input: typeof IssueEmailVerificationChallengeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.VerifyEmailVerificationChallenge
   */
  verifyEmailVerificationChallenge: {
    methodKind: "unary";
    input: typeof VerifyEmailVerificationChallengeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.IssuePhoneNumberVerificationChallenge
   */
  issuePhoneNumberVerificationChallenge: {
    methodKind: "unary";
    input: typeof IssuePhoneNumberVerificationChallengeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.VerifyPhoneNumberVerificationChallenge
   */
  verifyPhoneNumberVerificationChallenge: {
    methodKind: "unary";
    input: typeof VerifyPhoneNumberVerificationChallengeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Passwords
   *
   * @generated from rpc api.v1.ApiService.RegisterPassword
   */
  registerPassword: {
    methodKind: "unary";
    input: typeof RegisterPasswordRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.ApiService.VerifyPassword
   */
  verifyPassword: {
    methodKind: "unary";
    input: typeof VerifyPasswordRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_api, 0);

